import http from "@/utils/request";

class CustomsAccountBookApi {
  bindOrUpdate(data) {
    return http.sendRequest({
      METHOD_NAME: "customsAccountBook.bindOrUpdate",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {}
    });
  }

  listAccountList(data) {
    return http.sendRequest({
      METHOD_NAME: "customsAccountBook.list",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {}
    });
  }
  adjustStock(data) {
    return http.sendRequest({
      METHOD_NAME: "customsAccountBook.adjustStock",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {}
    });
  }

  adjustStockPageQuery(data) {
    return http.sendRequest({
      METHOD_NAME: "customsAccountBook.adjustStockPageQuery",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {}
    });
  }
}

export default new CustomsAccountBookApi();
